export const setToken = (state, payload) => state.token = payload;

export const setUser = (state, payload) => state.user = payload;

export const setLogin = (state, payload) => state.login = payload;

export const setAlert = (state, payload) => state.login.isAlert = payload;

export const updateUserFirstLogin = (state, payload) => state.user.is_first_login = payload;
